
  import { defineComponent, PropType } from 'vue';

  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import { TDatePickerMode } from '@/common/components/DateComponent/dateComponentMode';
  import { getDateRangeLimits, TDateRangeLimits, TDateRangeLimitsConfig } from '@/common/utils/dateRange';

  import RangeFieldLayout from './RangeFieldLayout.vue';
  import rangeFieldModel, { DEFAULT_RANGE_PLACEHOLDERS } from './rangeFieldModel';

  export default defineComponent({
    name: 'DateRangeField',
    components: { DateComponent, RangeFieldLayout },
    mixins: [rangeFieldModel],
    props: {
      mode: {
        type: String as PropType<TDatePickerMode>,
        default: 'date',
      },
      placeholders: {
        type: Array as PropType<string[]>,
        default: () => DEFAULT_RANGE_PLACEHOLDERS,
      },
      typeable: {
        type: Boolean,
        default: true,
      },
      hasInputMask: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      // Внешние границы диапазона (из конфигурации фильтра).
      limits: {
        type: Object as PropType<TDateRangeLimitsConfig>,
        default: () => ({}),
      },
    },
    computed: {
      rangeLimits(): TDateRangeLimits {
        return getDateRangeLimits({
          from: this.from,
          to: this.to,
          mode: this.mode,
          limits: this.limits,
        });
      },
    },
  });
